<template>
  <div>
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{message}}</span>
        </v-snackbar>
        <v-card class="neu-glow">
          <v-card-title primary-title>
            <div class="text-h5 pb-5">FAQS</div>
            <v-spacer></v-spacer>
            <v-div class="mr-6">
              <v-btn color="info" @click.stop="getData('refresh')">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn> 
              <v-btn color="success" @click.stop="editFAQ(null)">
                <v-icon color="white">mdi-plus</v-icon>
              </v-btn>             
            </v-div>           
          </v-card-title>
          
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else class="mx-4">
              <v-data-table
                dense
                fixed-header
                :headers="headers"
                :items="faqs"
                hide-default-footer
                :items-per-page=500
                :item-class="itemClass"
                :loading="loading"
                no-data-text="Nessun dato presente in archivio"
                no-results-text="Nessun Risultato estratto"
                loading-text="Consultazione archivio: attendi..."
              >
                  <!--
                    <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="editFAQ(item)" icon v-bind="attrs" v-on="on" class="float-left">
                          <v-icon color="success">mdi-book-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Modifica</span>
                    </v-tooltip>                        
                  </template>
                  -->
                  <template v-slot:[`item.A`]="{ item }">
                    <v-tooltip top max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="editFAQ(item)" icon v-bind="attrs" v-on="on" class="float-left">
                          <v-icon color="success">mdi-message-text</v-icon>
                        </v-btn>
                      </template>
                      <span v-html="item.A"></span>
                    </v-tooltip>                        
                  </template>

                  <template v-slot:[`item.active`]="{ item }">
                    <v-simple-checkbox
                      v-model="item.active"
                      color="success"
                      disabled
                    ></v-simple-checkbox>
                  </template>

              </v-data-table>
  <!--
                <v-col cols="9" md="7"  :key="fi">
                  <vue-editor :id="fi" v-model="f.A" :editorToolbar="customToolbar"  class="mx-2"  />
                </v-col>
                <v-col cols="3" md="1" :key="fi">
                  <v-btn class="ml-1" block @click="editFaq(f)" color="red">Modifica</v-btn>
                </v-col>
                -->
          </div>
        </v-card>
    </v-form>
    <v-dialog v-model="dialog_editFAQ" max-width="1200" v-if="editedFAQ">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Modifica FAQ
            </v-card-title>
            <v-row class="mx-5">
                <!--<v-col md="3" cols="6" v-for="(d,i) in slots.filter(s=> s!='Giorno')" :key="i">-->
                <v-col cols="12">
                  <v-text-field            
                    dense
                    counter
                    label="Domanda"
                    outlined
                    background-color="success lighten-4"
                    v-model=editedFAQ.Q
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" >
                  <vue-editor id="faq" v-model="editedFAQ.A" :editorToolbar="customToolbar"  class="mx-2"  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    class="mt-2"            
                    dense
                    counter
                    label="Note"
                    outlined
                    background-color="info lighten-4"
                    v-model=editedFAQ.R
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    class="mt-2"            
                    dense
                    counter
                    label="Ordinamento"
                    outlined
                    background-color="info lighten-4"
                    v-model=editedFAQ.sortOrder
                    persistent-placeholder
                    hide-details
                    reverse
                    type="number"
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>                                 
            </v-row>
            <v-divider class="my-3"></v-divider>
            <v-card-actions>
                <v-btn color="info"  @click="dialog_editFAQ = false">
                  Esci
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="warning" :loading="loading_update" @click="saveFAQ('unset')">
                  Cancella
                </v-btn>              
                <v-spacer></v-spacer>
                <v-btn color="success" :loading="loading_update" @click="saveFAQ('save')">
                  Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>  
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { VueEditor  } from "vue2-editor";
//import _ from 'lodash'
export default {
  components: { VueEditor },
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_editFAQ:false,
      dialog_accomplished:false,
      dialog_accomplished_message:'',
      faqs:[],
      editedFAQ:null,
      loading_refresh:false,
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Domanda',      value: 'Q',          align: 'left',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Risposta',     value: 'A',          align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Note',         value: 'remarks',    align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Ord.',         value: 'sortOrder',  align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Attiva',       value: 'active',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Azione',       value: 'actions',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],      
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        //[{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
      ],      
     
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    editFAQ(f)
    {
      this.editedFAQ=f;
      console.log(214,f)
      this.dialog_editFAQ=true;
    },
    async saveFAQ(a)
    {
        console.log(144,this.editedFAQ);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='unsetFAQ'
          f.active=0;
        }
        else
        {
          action='saveFAQ';
        }
        let payload={"action":action,"payload":JSON.stringify(this.editedFAQ)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editFAQ=false;
        }   
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"getFaqs"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.faqs=res.data.faqs;
                    console.log(282,this.faqs)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>